<template>
    <v-data-table :items="podaci"
                  :headers="headers()"
                  class="elevation-1"
                  dense
                  hide-actions
                  :pagination.sync="pagination">
      <template v-slot:items="props">
        <td> {{props.item.ImeObrazovanja}} </td>
        <td class="text-center"> {{props.item.ProduljenjeViewModel.ProgramTrajanje}} {{ $t('program_deadline.table_headers.days').toLowerCase() }} </td>
        <td class="text-center"> {{props.item.ProduljenjeViewModel.DatumIstekaUpisa}} </td>
        <td :class="getIstekaoClass(props.item.ProduljenjeViewModel.Istekao)">
          <b>{{ getUpisIstekao(props.item.ProduljenjeViewModel.Istekao) }}</b>
        </td>
      </template>
    </v-data-table>

</template>


<script>

  export default {
    name: 'DeadlineTable',
    props: {
      podaci: null
    },

    data() {
      return {
        pagination: {
          rowsPerPage: -1
        }
      }
    },

    methods: {
      getUpisIstekao(istekao) {
        var yesORno = (istekao ? yesORno = 1 : 2);
        return this.$tc('program_deadline.enrolment_expired', yesORno);
      },

      getIstekaoClass(istekao) {
        if (istekao) {
          return 'text-center red--text';
        } else {
          return 'text-center green--text';
        }
      },

      headers() {
        return [
          {
            sortable: false,
            text: this.$t('program_deadline.table_headers.start_date'),
            value: 'Datum'
          },
          {
            sortable: false,
            text: this.$t('program_deadline.table_headers.program_duration'),
            value: 'Trajanje',
            align: 'center'
          },
          {
            sortable: false,
            text: this.$t('program_deadline.table_headers.enrollment_deadline_expiration'),
            value: 'DatumIsteka',
            align: 'center'
          },
          {
            sortable: false,
            text: this.$t('program_deadline.table_headers.enrollment_expired'),
            value: 'Istekao',
            align: 'center'
          },
        ];
      },

      

    }
  }
</script>




// WEBPACK FOOTER //
// VueSrc/Education/program_deadline_components/DeadlineTable.vue